import { createFileRoute } from "@tanstack/react-router";

import { HStack } from "@/components/Layout";

import { DEVICE_TYPE_STEPS } from "../-constants/steps";
import useDeviceTypeParam from "../-hooks/useDeviceType";
import { getDeviceFormStoreContext } from "../-store/deviceFormStoreContext";

import InnerNavigation from "./-components/InnerNavigation";
import ManualForm from "./-components/ManualForm";
import { ProgressCard } from "./-components/ProgressCard";

export const Route = createFileRoute("/_staff/devices/add/$deviceType/")({
  component: () => <Form />,
});

function Form() {
  const { deviceType } = useDeviceTypeParam();
  const { context } = getDeviceFormStoreContext(deviceType);
  const store = context.createStore();
  const steps = DEVICE_TYPE_STEPS[deviceType];

  return (
    <context.Provider value={store}>
      <HStack className="w-full p-6 gap-6">
        <div className="shrink-0">
          <InnerNavigation steps={steps} />
        </div>
        <ManualForm className="grow min-w-[340px]" steps={steps} />
        <div className="shrink-0">
          <ProgressCard steps={steps} />
        </div>
      </HStack>
    </context.Provider>
  );
}
